'use strict';

exports.__esModule = true;
exports.List_B = exports.List_A = exports.WF_LIST_B = exports.WF_LIST_A = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsUtils = require('widgets-utils');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _style = require('./../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _reviewItem = require('widgets-utils/src/styles/review-item.scss');

var _reviewItem2 = _interopRequireDefault(_reviewItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WF_LIST_A = exports.WF_LIST_A = 'WF_LIST_A';
var WF_LIST_B = exports.WF_LIST_B = 'WF_LIST_B';

var _ref = _react2.default.createElement(_widgetsUtils.DoctifyLogo, null);

var List_A = exports.List_A = function (_React$Component) {
    (0, _inherits3.default)(List_A, _React$Component);

    function List_A() {
        (0, _classCallCheck3.default)(this, List_A);
        return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
    }

    List_A.prototype.renderReview = function renderReview(reviews, backgroundColor) {
        var _this2 = this;

        return reviews.map(function (review, i) {
            var dateSource = (0, _moment2.default)(review.timestamp_created);
            var date = dateSource.format("DD/MM/YYYY");
            return _react2.default.createElement(
                'div',
                { className: _style2.default['review-wrapper'] },
                _react2.default.createElement(_widgetsUtils.ReviewItem, {
                    key: i,
                    review: review,
                    rate: review.aggregate_score,
                    isReviewVerified: true,
                    showSource: true,
                    source: 'Doctify',
                    content: review.review.body,
                    date: date,
                    contentStyle: { 'max-height': '130px' },
                    classNames: _this2.props.classNames,
                    wrapperStyle: {
                        "background-color": backgroundColor
                    },
                    showFrame: _this2.props.reviewItemFrame
                })
            );
        });
    };

    List_A.prototype.render = function render() {
        var props = this.props;
        var reviewWordPostfix = props.totalReviews > 1 ? 's' : '';

        var bodyStyle = props.bodyStyle;
        var isBodyTransparent = bodyStyle && bodyStyle.backgroundColor && bodyStyle.backgroundColor === "transparent";
        var backgroundColor = props.reviewItemBackground ? props.reviewItemBackground : isBodyTransparent ? undefined : '#fff';

        return _react2.default.createElement(
            'div',
            {
                className: [_style2.default['wf-list'], isBodyTransparent && _reviewItem2.default['transparent-body'], isBodyTransparent && _style2.default['wf-list_transparent'], props.wrapperFrame === false && _style2.default['wf-list_no-frame']].join(" ")
            },
            _react2.default.createElement(
                'a',
                {
                    href: this.props.href,
                    target: '_blank',
                    rel: 'nofollow noopener'
                },
                _react2.default.createElement(
                    'div',
                    { className: _style2.default['wf-list__header'] },
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default['wf-list__verbal-container'] },
                        _react2.default.createElement(_widgetsUtils.VerbalRating, { rate: props.averageRating, isRateBold: true })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default['wf-list__star-container'] },
                        _react2.default.createElement(_widgetsUtils.Stars, { rate: props.averageRating })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _style2.default['wf-list__sub-header'] },
                    _react2.default.createElement(_widgetsUtils.PatientsReviewsCount, {
                        reviewsCount: props.totalReviews,
                        postfix: " patient review" + reviewWordPostfix + " on",
                        wrapperClass: _style2.default['numeric-rating']
                    }),
                    _ref
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _style2.default['wf-list__body'] },
                this.renderReview(props.reviews, backgroundColor)
            )
        );
    };

    return List_A;
}(_react2.default.Component);

var _ref2 = _react2.default.createElement(_widgetsUtils.DoctifyLogo, null);

var List_B = exports.List_B = function (_List_A) {
    (0, _inherits3.default)(List_B, _List_A);

    function List_B() {
        (0, _classCallCheck3.default)(this, List_B);
        return (0, _possibleConstructorReturn3.default)(this, _List_A.apply(this, arguments));
    }

    List_B.prototype.render = function render() {
        var props = this.props;
        var reviewWordPostfix = props.totalReviews > 1 ? 's' : '';

        var bodyStyle = props.bodyStyle;
        var isBodyTransparent = bodyStyle && bodyStyle.backgroundColor && bodyStyle.backgroundColor === "transparent";
        var backgroundColor = props.reviewItemBackground ? props.reviewItemBackground : isBodyTransparent ? undefined : '#fff';

        return _react2.default.createElement(
            'div',
            {
                className: [_style2.default['wf-list'], isBodyTransparent && _reviewItem2.default['transparent-body'], isBodyTransparent && _style2.default['wf-list_transparent'], props.wrapperFrame === false && _style2.default['wf-list_no-frame']].join(" ")
            },
            _react2.default.createElement(
                'a',
                {
                    href: this.props.href,
                    target: '_blank',
                    rel: 'nofollow noopener'
                },
                _react2.default.createElement(
                    'div',
                    { className: _style2.default['wf-list__header'] },
                    _react2.default.createElement(_widgetsUtils.Stars, { rate: props.averageRating })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _style2.default['wf-list__sub-header'] },
                    _react2.default.createElement(_widgetsUtils.PatientsReviewsCount, {
                        reviewsCount: props.totalReviews,
                        postfix: " patient review" + reviewWordPostfix + " on",
                        wrapperClass: _style2.default['numeric-rating']
                    }),
                    _ref2
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _style2.default['wf-list__body'] },
                this.renderReview(props.reviews, backgroundColor)
            )
        );
    };

    return List_B;
}(List_A);